import React, { isValidElement } from 'react';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../../../BaseComponents';
import { useMergeClasses, useTheme } from '../../../../../theme';
import { CdnIcon, IconTitle } from '@shared/ui';
import { Tip } from '@shared/ui';
import { Money } from '../../../../../Money';
import { getFirstCharName, MOBILE_MIN_WIDTH } from '../../../../../utils';
const PassTitle = ({ classes, title, icon, success, error, variant = 'default', headerButtonProps, tipProps, disabled, rightIcon, fieldsMap, money, oldPrice, onClear, onAdd }) => {
    const { t } = useTranslation('Passengers');
    const defaultTheme = useTheme('Entities').Passenger.PassTitle;
    const theme = useMergeClasses(defaultTheme, classes);
    const getContent = (React.createElement("div", { className: cn(theme.content, { [theme.fields]: fieldsMap }) },
        React.createElement("div", { className: theme.header },
            React.createElement("div", { className: theme.titleWrapper },
                React.createElement("span", { className: theme.title }, title),
                success && React.createElement(CdnIcon, { icon: "Info/Item Icluded", className: cn(theme.successIcon, theme.cdnIcon) })),
            tipProps && React.createElement(Tip, Object.assign({ variant: "cheap" }, tipProps))),
        headerButtonProps && (React.createElement(BaseButton, Object.assign({ className: theme.headerButton, variant: "text", children: t('Change accompanies') }, headerButtonProps))),
        fieldsMap && (React.createElement("div", { className: theme.fields }, Object.entries(fieldsMap).map(([key, value]) => (React.createElement("div", { key: key, className: theme.field }, value)))))));
    const iconContent = (React.createElement("div", { className: cn(theme.iconWrapper, {
            [theme.errorColor]: error,
            [theme.disabled]: disabled,
            [theme.variantAddToCompanions]: variant === 'add-to-companions',
            [theme.variantAdded]: variant === 'added',
            [theme.variantCompanionOffer]: variant === 'companion-offer',
            [theme.variantAccompanies]: variant === 'accompanies'
        }) }, variant === 'add-to-companions' ? (React.createElement(BaseButton, { onClick: onAdd, variant: "text" },
        React.createElement(CdnIcon, { icon: "Action/Add", className: theme.cdnIcon }))) : typeof icon === 'number' ? (React.createElement("span", null, icon)) : typeof icon === 'object' && icon !== null && !isValidElement(icon) ? ((() => {
        const passengerIcon = icon;
        return (React.createElement("span", null, getFirstCharName({
            firstName: passengerIcon.firstName,
            lastName: passengerIcon.lastName,
            middleName: passengerIcon.middleName
        }, 'firstName lastName')));
    })()) : typeof icon === 'string' ? (React.createElement(CdnIcon, { icon: icon, className: theme.cdnIcon })) : (icon)));
    const contentRight = rightIcon ? (React.createElement("div", { className: cn(theme.rightIcon) }, rightIcon)) : money ? (React.createElement("div", { className: theme.priceWrapper },
        oldPrice && React.createElement(Money, { money: oldPrice, moneyClassName: theme.oldPrice }),
        React.createElement(Money, { money: money, moneyClassName: theme.price }))) : onClear ? (React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH + 1 },
        React.createElement(BaseButton, { className: theme.clearButton, onClick: onClear, variant: "text" },
            t('Clear'),
            React.createElement(CdnIcon, { icon: "Action/Close-Clear", className: theme.clearIcon })))) : null;
    return (React.createElement("div", { className: theme.root },
        React.createElement(IconTitle, { className: cn({
                [theme.disabled]: disabled,
                [theme.iconContainer]: fieldsMap
            }), content: getContent, mainIcon: iconContent, contentRight: contentRight })));
};
export default PassTitle;
